/**
 * The composer's rotating placeholder.
 *
 * It rotates to show what kinds of question this thing answers, and it stops
 * the moment the investor is using the field: text swapping under a cursor is
 * the fastest way to make a composer feel like it is not listening.
 */

export const PLACEHOLDER_ROTATION_MS = 3800

/**
 * The first entry is the resting placeholder. The rest are examples, and they
 * are deliberately company-agnostic — the prototype's named a person and a
 * slide number from its own fixture deck.
 */
export const COMPOSER_PLACEHOLDERS = [
  'Ask anything about this company…',
  'What is the use of funds?',
  'Which numbers are dated, and where do they come from?',
  'Who else is on the team?',
  'Is any revenue machine-pulled?',
] as const

export interface PlaceholderRotationInput {
  isFocused: boolean
  hasValue: boolean
}

export function shouldRotatePlaceholder({
  isFocused,
  hasValue,
}: PlaceholderRotationInput): boolean {
  return !isFocused && !hasValue
}

export function nextPlaceholderIndex(index: number): number {
  return (index + 1) % COMPOSER_PLACEHOLDERS.length
}

export function placeholderAt(index: number): string {
  return COMPOSER_PLACEHOLDERS[index % COMPOSER_PLACEHOLDERS.length] ?? COMPOSER_PLACEHOLDERS[0]
}
